import React from 'react'

import { Box, Color, ResponsiveValue } from '@gousto-internal/citrus-react'

export const LoadingSkeleton = ({
  width,
  height = '18px',
}: {
  width: string
  height?: ResponsiveValue<string>
}) => (
  <Box
    bg={Color.ColdGrey_100}
    borderRadius={1}
    width={width}
    height={height}
    data-testid="loading-skeleton"
    aria-hidden="true"
  />
)
